import { PageWrap } from "common/PageWrap/PageWrap";
import { AdminQuestionnaireTable } from "features/admin/components/AdminQuestionnaireTable/AdminQuestionnaireTable";
import pageCover from "features/admin/PageCoverStyle.module.scss";
import * as React from "react";
import { FunctionComponent } from "react";

export const AdminQuestionnairesScreen: FunctionComponent = () => {
  return (
    <div className={pageCover.wrap}>
      <PageWrap>
        <AdminQuestionnaireTable />
      </PageWrap>
    </div>
  );
};
